import { render, staticRenderFns } from "./SingleWarehouseUsers.vue?vue&type=template&id=b56ec83e&"
import script from "./SingleWarehouseUsers.vue?vue&type=script&lang=js&"
export * from "./SingleWarehouseUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleWarehouseUsers.vue"
export default component.exports